import { render, staticRenderFns } from "./checkOrder.vue?vue&type=template&id=9b0fd496&scoped=true"
import script from "./checkOrder.vue?vue&type=script&lang=js"
export * from "./checkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0fd496",
  null
  
)

export default component.exports